import React from "react";
import { useTranslation } from "react-i18next";

export default function HaProfileConfigPDocs() {
  const { t } = useTranslation("help");

  const configData = {
    profile_type: "prompts_docs_llm",
    test_file_paths: {
      dos: [],
      llm: [],
      mcp: [],
      rto: [],
      docs: [
        {
          file_name: "",
          file_path: "",
          file_creation_method: ""
        }
      ],
      frame: [],
      prompts: [
        {
          file_name: "",
          file_path: "",
          file_creation_method: ""
        }
      ],
      custom_decision_tree: [
        {
          file_name: "",
          file_path: "",
          file_creation_method: ""
        }
      ],
      rc_prompts: []
    },
    prompts_testing: {
      enabled: false
    },
    malicious_doc_uploads: {
      enabled: false
    },
    adv_multi_attacks: {
      sub: {
        ama_backdoor: {
          enabled: false
        },
        ama_collusion: {
          enabled: false
        },
        ama_jb_classic: {
          enabled: false
        },
        ama_jb_reverse: {
          enabled: false
        },
        ama_crisis_manip: {
          enabled: false
        },
        ama_tool_exploit: {
          enabled: false
        },
        ama_jb_contextual: {
          enabled: false
        },
        ama_safe_boundary: {
          enabled: false
        },
        ama_jb_token_manip: {
          enabled: false
        },
        ama_info_extraction: {
          enabled: false
        },
        ama_decision_fatigue: {
          enabled: false
        },
        ama_jb_sophisticated: {
          enabled: false
        },
        ama_resource_exhaustion: {
          enabled: false
        }
      },
      enabled: false
    }
  };

  return (
    <div className="endpoint-container">
      <a href="#profile-config-prompts-docs" className="endpoint-title">
        {t("HaProfileConfigPDocs.title", "Profile Config (Prompts & Docs)")}
      </a>

      <pre className="code-block">
        <code>{JSON.stringify(configData, null, 2)}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 20px;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 2;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
          }
        }
      `}</style>
    </div>
  );
}